export const spine = {
    faqs: [
        { question: "How to book an appointment?"},
         { question: "What are the Clinic timings? "},
         { question: "What are the consultation charge?"},
         { question: "Are x ray facilities available in the clinic?"},
      ],
    // Add other company-specific contents here
    // For example: policies, guidelines, resources, etc.
    policies: [
      // ...policy objects
    ],
    guidelines: [
      // ...guideline objects
    ],
    // etc.
  };